export function range(begin: number, end: number) {
  const arr = [];
  for (let i = begin; i <= end; i++) {
    arr.push(i);
  }

  return arr;
}
